/**
 * 지도 후 차감 관리 검색 조건 화면
 */
import React, { Component } from 'react';
import { Navbar, Button, Form, InputGroup, Row, Col, Container } from 'react-bootstrap';
import { hakgwaList, banArr, sc_deduct, udfSetSearchCondition, udfSetScInfo } from '../../common/usr/stdtList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enUS from 'date-fns/locale/en-US';
import SideMenuCmp from './SideMenuCmp';

registerLocale('enUs', enUS);

class DeductSearchCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      SF_HAKGWA: sc_deduct.SF_HAKGWA,
      SF_GRADE: sc_deduct.SF_GRADE,
      SF_START_BAN: sc_deduct.SF_START_BAN,
      SF_END_BAN: sc_deduct.SF_END_BAN,
      SF_JG_APLY_YN: sc_deduct.SF_JG_APLY_YN,
      SF_JG_EDATE: sc_deduct.SF_JG_EDATE,
      usrInfo: null,
    };
  }

  handleChange = (e) => {
    udfSetSearchCondition('deduct', e.target.name, e.target.value);
  }

  // 0 채우기
  fn_fillZero = (val, length) => {
    let addZero = '';

    val = val.toString();

    if (val.length < length) {
      const diff = length - val.length;
      for (let i = 0; i < diff; i++) addZero += '0';
    }

    return addZero + val;
  }

  handleDateInput = (name, date) => {
    let val = date.getFullYear() + '-' + this.fn_fillZero(date.getMonth() + 1, 2) + '-' + this.fn_fillZero(date.getDate(), 2);
    udfSetSearchCondition('deduct', name, val);

    this.setState({
      [name]: val
    });
  }

  render() {
    const setHakgwaList = hakgwaList.map((str, idx) => (
      <option value={str} key={idx}>{str}</option>
    ));

    const setBanArr = banArr.map((ban, idx) => (
      <option value={ban} key={idx}>{ban} 반</option>
    ));

    return (
      <>
        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          검색조건
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <Container style={{ marginTop: '65px' }}>
          <Row>
            <Col>
              <Form.Label>학과</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_HAKGWA' defaultValue={this.state.SF_HAKGWA} onChange={this.handleChange}>
                <option value=''>전체</option>
                {setHakgwaList}
              </Form.Control>
            </Col>
            <Col>
              <Form.Label>학년</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_GRADE' defaultValue={this.state.SF_GRADE} onChange={this.handleChange}>
                <option value=''>전체</option>
                <option value='1'>1 학년</option>
                <option value='2'>2 학년</option>
                <option value='3'>3 학년</option>
                <option value='4'>4 학년</option>
                <option value='5'>5 학년</option>
                <option value='6'>6 학년</option>
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>반 범위</Form.Label>
              <InputGroup>
                <Form.Control as='select' name='SF_START_BAN' className="bg-light text-muted" defaultValue={this.state.SF_START_BAN} onChange={this.handleChange}>
                  {setBanArr}
                </Form.Control>
                <InputGroup.Append>
                  <InputGroup.Text>부터</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
            <Col>
              <Form.Label>&nbsp;</Form.Label>
              <InputGroup>
                <Form.Control as='select' name='SF_END_BAN' className="bg-light text-muted" defaultValue={this.state.SF_END_BAN} onChange={this.handleChange}>
                  {setBanArr}
                </Form.Control>
                <InputGroup.Append>
                  <InputGroup.Text>까지</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>차감적용구분</Form.Label>
              <Form.Control as='select' name='SF_JG_APLY_YN' className="bg-light text-muted" defaultValue={this.state.SF_JG_APLY_YN} onChange={this.handleChange}>
                <option value='Y'>적용</option>
                <option value='N'>미적용</option>
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className='fullInputGroup'>
              <Form.Label>지도종료일</Form.Label>
              <DatePicker
                todayButton={'TODAY'}
                dateFormat='yyyy-MM-dd'
                locale={enUS}
                customInput={
                  <InputGroup>
                    <Form.Control
                      type='text'
                      value={this.state.SF_JG_EDATE}
                      readOnly
                      className="bg-light text-muted"
                    />
                    <InputGroup.Append>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                    </InputGroup.Append>
                    <InputGroup.Append>
                      <InputGroup.Text>까지</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                }
                onChange={(val) => { this.handleDateInput('SF_JG_EDATE', val) }}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Link to='/usr/deductList' onClick={() => udfSetScInfo('deduct', true, false)}>
                <Button className='mt-2 btn btn-height btn-school-life col'>검색</Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default DeductSearchCmp;